import { Link } from "react-router-dom";

const MESSENGER_URL =
  "https://m.me/jglennverano?text=Hi%20I%20want%20to%20ask%20about%20my%20car%20loan%20options";
const INTAKE_FORM_URL = "https://exitmycar.com/intake-form.php?source=contact-review";

const gradientStyle = {
  background: "linear-gradient(135deg, #4F7CFF 0%, #7B8CFF 100%)",
};
const gradientHover = {
  background: "linear-gradient(135deg, #3D6AE8 0%, #6B7CE8 100%)",
};

export default function ContactSection() {
  return (
    <>
      <div style={{ height: "1px", backgroundColor: "#E8EEFF" }} />

      <section
        id="contact"
        className="py-24 lg:py-32"
        style={{ backgroundColor: "#FFFFFF" }}
      >
        <div className="mx-auto max-w-7xl px-6 lg:px-8">

          {/* Section header */}
          <div className="mb-14 text-center">
            <p
              className="text-xs font-bold uppercase tracking-widest mb-3"
              style={{ color: "#4F7CFF" }}
            >
              Get in Touch
            </p>
            <h2
              className="text-3xl font-bold tracking-tight sm:text-4xl"
              style={{ color: "#1E293B" }}
            >
              Choose how you&apos;d like to get help
            </h2>
            <p className="mt-3 text-sm" style={{ color: "#64748B" }}>
              Pick whichever feels easiest — our team is ready on both.
            </p>
          </div>

          <div className="grid gap-12 lg:grid-cols-2 lg:items-start">

            {/* Left: contact info */}
            <div
              className="rounded-2xl p-8"
              style={{
                backgroundColor: "#F8FAFC",
                border: "1px solid #E8EEFF",
              }}
            >
              <div className="space-y-5">
                {/* Phone */}
                <div className="flex items-start gap-4">
                  <div
                    className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg"
                    style={{ backgroundColor: "#EBF0FF" }}
                  >
                    <i className="ri-phone-line text-lg" style={{ color: "#4F7CFF" }} />
                  </div>
                  <div>
                    <div className="text-xs font-medium" style={{ color: "#94A3B8" }}>
                      Call / Viber / WhatsApp
                    </div>
                    <div className="text-sm font-semibold" style={{ color: "#1E293B" }}>
                      +63 XXX XXX XXXX
                    </div>
                  </div>
                </div>

                {/* Facebook Page — custom clickable item */}
                <div className="flex items-start gap-4">
                  <div
                    className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg"
                    style={{ backgroundColor: "#EBF0FF" }}
                  >
                    <i className="ri-facebook-box-line text-lg" style={{ color: "#4F7CFF" }} />
                  </div>
                  <div>
                    <div className="text-xs font-medium" style={{ color: "#94A3B8" }}>
                      Facebook Page
                    </div>
                    <a
                      href="https://www.facebook.com/cebuautomanagement"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-1.5 text-sm font-semibold transition-all duration-150 cursor-pointer"
                      style={{ color: "#1877F2" }}
                      onMouseEnter={(e) => {
                        const el = e.currentTarget as HTMLElement;
                        el.style.color = "#0e5fc2";
                        el.style.textDecoration = "underline";
                      }}
                      onMouseLeave={(e) => {
                        const el = e.currentTarget as HTMLElement;
                        el.style.color = "#1877F2";
                        el.style.textDecoration = "none";
                      }}
                    >
                      <i className="ri-facebook-fill text-base" />
                      Visit our Facebook Page
                    </a>
                    <div className="mt-0.5 text-xs" style={{ color: "#94A3B8" }}>
                      Message us directly on Facebook
                    </div>
                  </div>
                </div>

                {/* Based In */}
                <div className="flex items-start gap-4">
                  <div
                    className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg"
                    style={{ backgroundColor: "#EBF0FF" }}
                  >
                    <i className="ri-map-pin-2-line text-lg" style={{ color: "#4F7CFF" }} />
                  </div>
                  <div>
                    <div className="text-xs font-medium" style={{ color: "#94A3B8" }}>
                      Based In
                    </div>
                    <div className="text-sm font-semibold" style={{ color: "#1E293B" }}>
                      Cebu City, Philippines
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="mt-8 rounded-xl p-5 flex items-start gap-3"
                style={{
                  backgroundColor: "#FFFFFF",
                  border: "1px solid #E8EEFF",
                }}
              >
                <div className="flex h-6 w-6 flex-shrink-0 items-center justify-center mt-0.5">
                  <i
                    className="ri-shield-check-line text-xl"
                    style={{ color: "#22C55E" }}
                  />
                </div>
                <div>
                  <span className="text-sm font-bold block" style={{ color: "#1E293B" }}>
                    Your information is safe with us
                  </span>
                  <p className="mt-1 text-xs leading-6" style={{ color: "#475569" }}>
                    We will never share your details with third parties without your
                    consent. All consultations are handled discreetly.
                  </p>
                </div>
              </div>

              {/* Response time badge */}
              <div
                className="mt-5 rounded-xl p-4 flex items-center gap-3"
                style={{ backgroundColor: "#F0FDF4", border: "1px solid #BBF7D0" }}
              >
                <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full" style={{ backgroundColor: "#DCFCE7" }}>
                  <i className="ri-time-line text-base" style={{ color: "#16A34A" }} />
                </div>
                <p className="text-xs font-medium" style={{ color: "#15803D" }}>
                  We typically respond within <strong>1 business day</strong> for form submissions — or within minutes on Messenger.
                </p>
              </div>
            </div>

            {/* Right: Primary Messenger + Secondary Intake CTA */}
            <div className="flex flex-col gap-6">

              {/* PRIMARY: Messenger CTA */}
              <div
                className="rounded-2xl p-8"
                style={{
                  background: "linear-gradient(135deg, #0073E6 0%, #0099FF 100%)",
                  boxShadow: "0 8px 40px rgba(0,132,255,0.25)",
                }}
              >
                <div className="flex items-center gap-2 mb-1">
                  <div className="flex h-5 w-5 items-center justify-center rounded-full" style={{ backgroundColor: "rgba(255,255,255,0.25)" }}>
                    <i className="ri-flashlight-line text-xs text-white" />
                  </div>
                  <p className="text-xs font-bold uppercase tracking-widest text-white" style={{ opacity: 0.9 }}>
                    Get help instantly
                  </p>
                </div>

                <h3 className="mt-3 text-2xl font-bold text-white leading-snug">
                  Chat with us on Messenger
                </h3>
                <p className="mt-2 text-sm text-white" style={{ opacity: 0.85 }}>
                  Ask about your car loan situation right now. No forms,
                  no waiting — real answers from a real person.
                </p>

                <a
                  href={MESSENGER_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-6 flex items-center justify-center gap-3 w-full whitespace-nowrap rounded-xl py-4 font-bold text-base transition-all duration-200 cursor-pointer"
                  style={{
                    backgroundColor: "#FFFFFF",
                    color: "#0073E6",
                  }}
                  onMouseEnter={(e) => {
                    const el = e.currentTarget as HTMLElement;
                    el.style.backgroundColor = "#F0F8FF";
                    el.style.transform = "scale(1.02)";
                  }}
                  onMouseLeave={(e) => {
                    const el = e.currentTarget as HTMLElement;
                    el.style.backgroundColor = "#FFFFFF";
                    el.style.transform = "scale(1)";
                  }}
                >
                  <span className="flex h-6 w-6 items-center justify-center flex-shrink-0">
                    <i className="ri-messenger-line text-xl" />
                  </span>
                  Open Messenger Now
                </a>

                <div className="mt-4 flex items-center justify-center gap-2">
                  <span className="inline-block h-2 w-2 rounded-full" style={{ backgroundColor: "#4ADE80" }} />
                  <p className="text-xs font-medium text-white" style={{ opacity: 0.85 }}>
                    Usually replies within a few minutes
                  </p>
                </div>
              </div>

              {/* SECONDARY: Intake Form CTA */}
              <div
                className="rounded-2xl p-8"
                style={{
                  backgroundColor: "#FFFFFF",
                  border: "1px solid #E8EEFF",
                }}
              >
                <div className="flex items-center gap-3 mb-5">
                  <div className="flex-1 h-px" style={{ backgroundColor: "#E8EEFF" }} />
                  <span className="text-xs font-semibold whitespace-nowrap px-2" style={{ color: "#94A3B8" }}>
                    Prefer a structured review?
                  </span>
                  <div className="flex-1 h-px" style={{ backgroundColor: "#E8EEFF" }} />
                </div>

                <div
                  className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl"
                  style={{ backgroundColor: "#EBF0FF" }}
                >
                  <i className="ri-file-list-3-line text-2xl" style={{ color: "#4F7CFF" }} />
                </div>

                <h4 className="text-lg font-bold" style={{ color: "#1E293B" }}>
                  Tell us about your vehicle
                </h4>
                <p className="mt-1.5 text-sm leading-6" style={{ color: "#475569" }}>
                  Complete this short form so our team can review your situation. We&apos;ll follow up within 1 business day.
                </p>

                <ul className="mt-5 space-y-2.5">
                  {[
                    "Full name, phone &amp; email",
                    "Vehicle year, make &amp; model",
                    "Monthly payment &amp; pay-off amount",
                    "Whether payments are current",
                  ].map((item, i) => (
                    <li key={i} className="flex items-center gap-2.5 text-sm" style={{ color: "#475569" }}>
                      <i className="ri-checkbox-circle-line text-sm flex-shrink-0" style={{ color: "#4F7CFF" }} />
                      <span dangerouslySetInnerHTML={{ __html: item }} />
                    </li>
                  ))}
                </ul>

                <Link
                  to="/intake"
                  className="mt-6 block w-full whitespace-nowrap rounded-xl py-3.5 text-center text-sm font-semibold text-white transition cursor-pointer"
                  style={gradientStyle}
                  onMouseEnter={(e) =>
                    Object.assign((e.currentTarget as HTMLElement).style, gradientHover)
                  }
                  onMouseLeave={(e) =>
                    Object.assign((e.currentTarget as HTMLElement).style, gradientStyle)
                  }
                >
                  Get Free Review
                </Link>

                <p className="mt-2 text-center text-xs" style={{ color: "#94A3B8" }}>
                  Takes less than 1 minute
                </p>

                <p className="mt-4 text-center text-xs" style={{ color: "#94A3B8" }}>
                  Confidential. No pressure. PH-based team.
                </p>
              </div>

            </div>
          </div>
        </div>
      </section>
    </>
  );
}
